import { takeLatest, call, put, fork, select } from 'redux-saga/effects'

import { indicateProgress } from 'api'
import { sendGTAGEvent } from 'analytics/utils'
import { paymentSuccess } from 'basket/actions'
import { userSelector, userAccountIdSelector } from 'auth/selectors'
import { verifyGuestCreditCard } from 'booking/actions'
import { CREDIT_CARD_PAYMENT_METHOD } from 'booking/constants'

import * as creditCardConstants from 'credit-cards/constants'
import * as creditCardActions from 'credit-cards/actions'
import * as creditCardApi from 'credit-cards/grsApi'
import { detectCardType } from 'credit-cards/utils'

import * as constants from 'credit-cards/sixcards/constants'
import * as api from 'credit-cards/sixcards/api'

function* sixcardsTokenizationSaga() {
    yield takeLatest(constants.ADD_CREDIT_CARD, function* ({ name, cardNumber, expiryMonth, expiryYear, zipCode }) {
        try {
            yield call(indicateProgress, { names: ['sixcardsTokenization'], clearPending: true }, function* () {
                const user = yield select(userSelector)
                if (user) {
                    const userId = yield select(userAccountIdSelector)
                    const cardExpiryMMYY = `0${expiryMonth}`.substr(-2) + expiryYear.toString().substr(-2)
                    const strippedCardNumber = cardNumber.replace(/ /g, '')

                    const response = yield call(
                        api.createCCToken,
                        user.token,
                        strippedCardNumber,
                        cardExpiryMMYY,
                        zipCode
                    )

                    const cardData = {
                        ...response,
                        CardType: detectCardType(strippedCardNumber),
                        Name: name,
                        CardProcessor: 'GETNET',
                    }

                    yield call(creditCardApi.saveCardData, user.token, cardData)
                    yield put(creditCardActions.addPaymentMethodSuccess())
                    sendGTAGEvent(
                        'add_payment_method',
                        {
                            payment_type: CREDIT_CARD_PAYMENT_METHOD,
                        },
                        userId
                    )
                }
            })
        } catch (ex) {}
    })
}

// SixCards fake payment flow. At the moment there is no extra calls done to verify payment,
// but according to TravelScience there will be 3dSecure veirfication added later.
// Therefore we are currently immediately calling payment success
function* sixcardsPaymentSaga() {
    yield takeLatest(creditCardConstants.INIT_PAYMENT, function* () {
        yield put(paymentSuccess())
    })
}

export function* rootSaga() {
    yield fork(sixcardsTokenizationSaga)
    yield fork(sixcardsPaymentSaga)
}
